var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ui-dialog",
    {
      ref: "dialog",
      attrs: { title: "Create new stream", closable: "" },
      on: {
        close: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c(
        "ui-radio-group",
        {
          model: {
            value: _vm.isExternal,
            callback: function ($$v) {
              _vm.isExternal = $$v
            },
            expression: "isExternal",
          },
        },
        [
          _c("ui-radio", {
            attrs: { value: false, label: "Use this cloud service" },
          }),
          _vm._v(" "),
          _c("ui-radio", {
            attrs: {
              value: true,
              label: "Use third-party RTMP service (e.g. YouTube or Facebook)",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("ui-input", {
        attrs: { label: "Stream title" },
        model: {
          value: _vm.streamTitle,
          callback: function ($$v) {
            _vm.streamTitle = $$v
          },
          expression: "streamTitle",
        },
      }),
      _vm._v(" "),
      _vm.isExternal
        ? _c("ui-input", {
            attrs: {
              label: "RTMP URL",
              hint: "Concatenate server URL and stream key separated by a slash (/), to form a complete URL",
            },
            model: {
              value: _vm.streamURI,
              callback: function ($$v) {
                _vm.streamURI = $$v
              },
              expression: "streamURI",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("ui-checkbox", {
        attrs: { label: "Use as default" },
        model: {
          value: _vm.isDefaultStream,
          callback: function ($$v) {
            _vm.isDefaultStream = $$v
          },
          expression: "isDefaultStream",
        },
      }),
      _vm._v(" "),
      _c(
        "ui-dialog-footer",
        [
          _c("ui-button", {
            attrs: {
              disabled: _vm.isFetching || _vm.streamTitle.length === 0,
              primary: "",
              text: "Create",
              tooltip: "Create stream",
            },
            on: { click: _vm.createStream },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }